import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';
import { Table } from 'react-bootstrap';

const TableTransposedRow = ({ tableRow }) => {
  try {
    if (tableRow?.props?.children > 2)
      throw new Error(
        'TableTransposed cannot render more than two columns in compact mode.',
      );
    else {
      const header = tableRow?.props?.children[0];
      const value = tableRow?.props?.children[1];
      return (
        <tr
          className={tableRow?.props?.className}
          style={tableRow?.props?.style}
        >
          <td>
            <div
              className={header?.props?.className}
              style={header?.props?.style}
            >
              <strong>{header?.props?.children}</strong>
            </div>
            <div
              className={value?.props?.className}
              style={value?.props?.style}
            >
              {value?.props?.children}
            </div>
          </td>
        </tr>
      );
    }
  } catch (error) {
    console.error(error); // eslint-disable-line no-console
  }
  return '';
};

TableTransposedRow.propTypes = {
  tableRow: PropTypes.node.isRequired,
};

const TableTransposed = ({ children, className = '', isCompact = false }) => {
  const childrenCount = children.length;
  return (
    <Table
      bordered
      className={classNames(
        'table-layout-fixed table-transposed thead-light',
        className,
      )}
    >
      {!isCompact ? (
        <tbody>{children}</tbody>
      ) : (
        <tbody>
          {!childrenCount && <TableTransposedRow tableRow={children} />}
          {childrenCount >= 2 &&
            children.map((tableRow, index) => {
              const getId = `${tableRow.type}-${index}`;
              return <TableTransposedRow key={getId} tableRow={tableRow} />;
            })}
        </tbody>
      )}
    </Table>
  );
};

TableTransposed.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isCompact: PropTypes.bool,
};

TableTransposed.Row = TableTransposedRow;

export default TableTransposed;
